//@flow
import * as React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import type { WrapCheckbox$Type } from './flowTypes'

const WrapCheckbox = ({ input,label,meta }:WrapCheckbox$Type ) => (
  <div>
    <Checkbox
      checked={input.value ? true : false}
      onChange={input.onChange}
    />
    &nbsp;
    {label}
    &nbsp;{meta && meta.error? ( <span style={{color: 'red'}} >**{meta.error}</span>  ):null}
  </div>
)

export default WrapCheckbox;


// WEBPACK FOOTER //
// ./src/components/common/WrapCheckbox.js